/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

export enum Products {
  ServerlessEndpoints = 'serverless-endpoints',
  DedicatedEndpoints = 'dedicated-endpoints',
  Container = 'container',
}

export const isProduct = (value: string | null | undefined): value is Products => {
  return Object.values(Products).includes(value as any);
};

export const CONTAINER_FREE_TRIAL_DAYS = 60;
